export const monthsEvents = [
  {
    month: 'May',
    monthNumber: 5,
    events: [
      {
        day: 7,
        date: new Date(2023, 4, 7),
        availabilities: [
          { time: '9:00 AM', booked: false, doctorID: 3 },
          { time: '10:00 AM', booked: false, doctorID: 3 },
          { time: '11:00 AM', booked: true, doctorID: 4 },
          { time: '12:00 PM', booked: false, doctorID: 1 },
          { time: '12:30 PM', booked: false, doctorID: 1 },
          { time: '1:00 PM', booked: false, doctorID: 3 },
          { time: '1:30 PM', booked: false, doctorID: 2 },
          { time: '2:00 PM', booked: true, doctorID: 4 },
          { time: '3:00 PM', booked: false, doctorID: 3 },
          { time: '3:30 PM', booked: false, doctorID: 3 },
          { time: '4:00 PM', booked: false, doctorID: 2 },
          { time: '5:00 PM', booked: false, doctorID: 1 },
          { time: '6:00 PM', booked: false, doctorID: 1 },
        ]
      },
      {
        day: 8,
        date: new Date(2023, 4, 8),
        availabilities: [
          { time: '9:00 AM', booked: false, doctorID: 2 },
          { time: '10:00 AM', booked: false, doctorID: 2 },
          { time: '11:00 AM', booked: true, doctorID: 4 },
          { time: '12:00 PM', booked: false, doctorID: 4 },
          { time: '1:00 PM', booked: false, doctorID: 1 },
          { time: '2:00 PM', booked: true, doctorID: 3 },
          { time: '3:00 PM', booked: false, doctorID: 3 },
          { time: '4:00 PM', booked: false, doctorID: 1 },
          { time: '5:00 PM', booked: false, doctorID: 1 },
          { time: '6:00 PM', booked: true, doctorID: 3 },
        ]
      },
      {
        day: 9,
        date: new Date(2023, 4, 9),
        availabilities: [
          { time: '9:00 AM', booked: false, doctorID: 1 },
          { time: '10:00 AM', booked: false, doctorID: 4 },
          { time: '11:00 AM', booked: true, doctorID: 4 },
          { time: '12:00 PM', booked: true, doctorID: 4 },
          { time: '1:00 PM', booked: false, doctorID: 4 },
          { time: '2:00 PM', booked: true, doctorID: 1 },
          { time: '3:00 PM', booked: false, doctorID: 3 },
          { time: '4:00 PM', booked: false, doctorID: 3 },
          { time: '5:00 PM', booked: true, doctorID: 2 },
          { time: '6:00 PM', booked: true, doctorID: 1 },
        ]
      }
    ]
  },
  {
    month: 'June',
    monthNumber: 6,
    events: [
      {
        day: 1,
        date: new Date(2023, 5, 1),
        availabilities: [
          { time: '9:00 AM', booked: true, doctorID: 1 },
          { time: '10:00 AM', booked: true, doctorID: 3 },
          { time: '11:00 AM', booked: true, doctorID: 3 },
          { time: '12:00 PM', booked: false, doctorID: 4 },
          { time: '1:00 PM', booked: false, doctorID: 4 },
          { time: '2:00 PM', booked: true, doctorID: 4 },
          { time: '3:00 PM', booked: false, doctorID: 4 },
          { time: '4:00 PM', booked: false, doctorID: 4 },
          { time: '5:00 PM', booked: false, doctorID: 4 },
          { time: '6:00 PM', booked: false, doctorID: 2 },
        ]
      },
    ]
  },
]